export enum BasketfulEvents {
  WIDGET_CLICK = 'basketful.widget_click',
  VIEWED_PAGE = 'basketful.viewedPage',
  POSTAL_CODE_CHANGED = 'basketful.postalCodeChanged',
  ADD_TO_CART = 'basketful.addToCart',
  CONFIRMED_ADD_TO_CART = 'basketful.confirmedAddToCart',
  WIDGET_CLOSE = 'basketful.widget_close'
}

export interface IBasketfulUtmParams {
  // eslint-disable-next-line
  utm_term: string;
}

export interface IBasketfulProduct {
  itemText: string;
  productTitle: string;
  quantity: number;
  unitPrice: string;
}

export interface IBasketfulOptions {
  recipeUrl: string | null;
  bundleId: string | null;
  bundleOnlyUpcs: string | null;
  utmParams: IBasketfulUtmParams | null;
}

export interface IBasketful {
  openBasketful: (options: IBasketfulOptions) => void;
}

export interface IBasketfulWidgetClickEvent {
  eventName: string;
}

export interface IBasketfulSwapEvent {
  eventName: string;
  newProductTitle: string;
  oldProductTitle: string;
  retailer: string;
}

export interface IBasketfulViewedPageEvent {
  contentId: string;
  eventName: string;
  products: IBasketfulProduct[];
  retailer: string;
}

export interface IBasketfulPostalCodeChangedEvent {
  eventName: string;
  eventType: string;
  newZip: string;
  oldZip: string;
}

export interface IBasketfulAddToCartEvent {
  eventName: string;
  eventType: string;
  products: IBasketfulProduct[];
  retailer: string;
  total: number;
}

export interface IBasketfulConfirmedAddToCartEvent {
  eventName: string;
  products: IBasketfulProduct[];
  retailer: string;
  total: number;
}

export interface IBasketfulWidgetCloseEvent {
  eventName: string;
}

export const ContainsEvent = (eventName: string): boolean => {
    switch (eventName) {
    case BasketfulEvents.ADD_TO_CART:
    case BasketfulEvents.CONFIRMED_ADD_TO_CART:
    case BasketfulEvents.POSTAL_CODE_CHANGED:
    case BasketfulEvents.VIEWED_PAGE:
    case BasketfulEvents.WIDGET_CLICK:
    case BasketfulEvents.WIDGET_CLOSE:
        return true;
    default:
        return false;
    }
};
